module.exports = __webpack_public_path__ + "static/img/logo.7dd1d33.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.svg
// module id = 633
// module chunks = 129